import React, {useState} from "react";
import VHSRegistrationModal, {IVHSRegistrationModalProps} from "./VHSRegistrationModal";
import {IBaseElementProps} from "../BasicElement";
import Button from "../Button";
import Modal from '../Modal';

export interface IVHSNewRegistrationProps extends IBaseElementProps {
	settings?: IVHSRegistrationModalProps;
}

const VHSNewRegistration: React.FC<IVHSNewRegistrationProps> = ({
	settings,
}) => {
	const [ formLoaded,setFormLoaded ] = useState(false);
	const [ creatingStudent,setCreatingStudent ] = useState(false);
	const handleAdd = () => {
		setCreatingStudent( true );
		setTimeout(() => {
			setFormLoaded(true);
		}, 500);
	}

	const allowCancel = () => {
		setCreatingStudent( false );
	};
	return (
		<>
		<Button
			className="btn btn-primary btn-sm"
			onClick={handleAdd}
		>
			Add
		</Button>
		{creatingStudent && (
			<Modal
				id="vhs-cart-add"
				className="vhs-cart__modal"
				modalClassNames={['modal-dialog-centered']}
				headerClassNames={[]}
				bodyClassNames={[]}
				closeOnOutsideClick={false}
				onCancel={() => allowCancel()}
				trapFocus={true}
			>
				<VHSRegistrationModal
					formLoaded={formLoaded}
					setCreatingStudent={setCreatingStudent}
					setFormLoaded={(value) => setFormLoaded(value)}
					creatingStudent={creatingStudent}
					studentRegistrationForm={settings.studentRegistrationForm}
					pluginURI={settings.pluginURI}
					stylesheetURI={settings.stylesheetURI}
				/>
			</Modal>
		) }
		</>
	);
};
export default VHSNewRegistration;
